import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/beneficiario-externo';

/**
 * GET Beneficiarios Externos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getBeneficiariosExternos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Beneficiario Externo
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getBeneficiarioExterno = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Benificiaio Externo
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postBeneficiarioExterno = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Benificiario Externo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchBeneficiarioExterno = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Benificiario Externo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const deleteBeneficiarioExterno = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
